import dayjs from 'dayjs';
import { jwtDecode } from 'jwt-decode';
import { JWTToken, LocalStorageKey } from '@sonar-software/sonar-ts-types';

export function getJWTToken(): string | undefined {
	const authTokenStr = localStorage.getItem(LocalStorageKey.AuthToken);

	if (!authTokenStr) {
		return;
	}

	const authTokenObj = JSON.parse(authTokenStr);
	const { token } = authTokenObj;

	return token;
}

export function decodeJWT(): JWTToken {
	const token = getJWTToken();

	return jwtDecode(token || '');
}

export function isJWTExpired(exprationInSeconds: number): boolean {
	const unixTimestamp = dayjs().unix();

	return dayjs(exprationInSeconds).isAfter(unixTimestamp);
}

export function removeJWTToken(): void {
	localStorage.removeItem(LocalStorageKey.AuthToken);
}

export function setJWTToken(token: string): void {
	localStorage.setItem(LocalStorageKey.AuthToken, JSON.stringify({ token }));
}
